var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0928 0C14.3247 0 14.56 0.0965553 14.7359 0.284841C15.088 0.661767 15.088 1.28503 14.7359 1.66196L8.14701 8.71516C7.97694 8.8972 7.73702 9 7.50394 9C7.27305 9 7.04293 8.91004 6.86087 8.71516L0.280977 1.671C-0.0876398 1.29962 -0.09237 0.661646 0.259747 0.28472C0.611864 -0.0922061 1.1941 -0.0922061 1.54621 0.28472L7.49217 6.66232L13.45 0.284654C13.6262 0.0960164 13.8613 0 14.0928 0Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowDark);
export default __webpack_public_path__ + "static/media/dropdown_arrow_dark.f12c8530be55bfd3f898b81d6b607677.svg";
export { ForwardRef as ReactComponent };